import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import SideBar from "../other/SideBar";
import NavBar from "../other/NavBar";
import LoadingModal from "../../loader/LoadingModal";
import {
  AddStaffURL,
  GetStaffTypeListURL,


} from "../../assets/api/BaseURL";
import Notification from "../other/Notification";
import { useToast } from "../../../context/ToastContext";
import { Tooltip } from 'react-tooltip'

const AddStaff = () => {
  const navigate = useNavigate();
  const { addToast } = useToast();
  const imageRef = useRef(null);
  const [token, setToken] = useState("");
  const [toggleSideBar, setToggleSideBar] = useState(false);
  const [canvas, setCanvas] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [image, setImage] = useState("");
  const maxImageSize = 1024 * 1024;
  const maxImageWidth = 500;
  const maxImageHeight = 500;
  const [staffTypeOptions, setStaffTypeOptions] = useState([]);
  const [staffType, setStaffType] = useState([]);
  const [selectedStaffType, setSelectedStaffType] = useState('');
  const [enablePasscode, setEnablePasscode] = useState(0);



  const [formData, setFormData] = useState({
    name: "",
    phoneNumber: "",
    email: "",
    address: "",
    userName: "",
    pass_code: "",
    password: "",
    description: "",
    status: true,
    type: "",
    image: "",
  });

  const [StaffPermissions, setStaffPermissions] = useState([]);


  const handleInputStafe = (value) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      type: value,
    }));
    setError("");
    setSuccess("");
  };

  const handleToggleSidebar = (e) => {
    e.preventDefault();
    setToggleSideBar(!toggleSideBar);
  };

  const handleToggleOffCanvas = (e) => {
    e.preventDefault();
    setCanvas(!canvas);
  };

  const handleBackClick = (e) => {
    e.preventDefault();
    navigate("/view_staff");
  };





  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (type === "checkbox") {
      setFormData({
        ...formData,
        [name]: checked,
      });
    } else {
      setFormData({
        ...formData,
        [name]: value,
      });
    }
    setError("");
    setSuccess("");
  };



  function isImageSizeValid(file) {
    if (file && file.size) {
      return file.size <= maxImageSize;
    }
    return false;
  }

  function isImageDimensionsValid(file) {
    if (file) {
      const image = new Image();
      image.src = URL.createObjectURL(file);

      return new Promise((resolve) => {
        image.onload = () => {
          const width = image.width;
          const height = image.height;

          const isValidDimensions =
            width <= maxImageWidth && height <= maxImageHeight;

          resolve(isValidDimensions);
        };
      });
    }

    return false;
  }

  const handleAddStaff = async (e) => {
    e.preventDefault();

    const mobileNumberPattern = /^\d{10}$/;


    if (formData.name === "" || formData.name.trim() === "") {
      setError("Name cannot be empty");
      setSuccess("");
    } else if (formData.name.length > 30) {
      setError("Name cannot exceed 30 characters.");
      setSuccess("");
    } else if (formData.phoneNumber === "") {
      setError("Phone Number cannot be empty");
      setSuccess("");
    } else if (!mobileNumberPattern.test(formData.phoneNumber)) {
      setError("Please enter a valid 10-digit Phone number.");
      setSuccess("");
    } else if ((formData.userName === "" || formData.userName.trim() === "")) {
      setError("User Name cannot be empty");
      setSuccess("");
    } else if ((formData.password === "" || formData.password.trim() === "")) {
      setError("Password cannot be empty");
      setSuccess("");
    } else if ((formData.pass_code === "" || formData.pass_code === "") && enablePasscode) {
      setError("Pass code cannot be empty");
      setSuccess("");
    }


    else if (formData.type === "") {
      setError("Please Select Staff Type");
      setSuccess("");
    } else if (image && !isImageSizeValid(image)) {
      setError(`Image size cannot be greater than ${maxImageSize / 1024}kb`);
      imageRef.current.value = "";
      setImage("");
      setSuccess("");
    } else if (image && !(await isImageDimensionsValid(image))) {
      setError(
        `Image Dimensions cannot be greater than ${maxImageWidth}*${maxImageHeight}`
      );
      imageRef.current.value = "";
      setImage("");
      setSuccess("");
    } else {
      // const data = {
      //   name: formData.name,
      //   phone_number: formData.phoneNumber,
      //   email: formData.email,
      //   address: formData.address,
      //   username: formData.userName,
      //   password: formData.password,
      //   description: formData.description,
      //   type: formData.type,
      //   status: formData.status ? 1 : 0,
      // };

      const dataToSend = new FormData();
      dataToSend.append("name", formData.name.trim());
      dataToSend.append("phone_number", formData.phoneNumber.trim());
      dataToSend.append("email", formData.email.trim());
      dataToSend.append("address", formData.address.trim());
      dataToSend.append("username", formData.userName.trim());
      dataToSend.append("password", formData.password.trim());
      dataToSend.append("pass_code", formData.pass_code);
      dataToSend.append("enablePasscode", enablePasscode);


      dataToSend.append("description", formData.description.trim());
      dataToSend.append("type", formData.type);
      dataToSend.append("status", formData.status ? 1 : 0);
      dataToSend.append("staff_image", image ? image : formData.image);

      dataToSend.append("app_permission", JSON.stringify(getFlattenedPermissionObject()));

      try {
        const response = await axios({
          method: "post",
          url: AddStaffURL,
          data: dataToSend,
          headers: {
            "Content-Type": "multipart/form-data",
            authorization: `Bearer ${token}`,
          },
        });

        if (response.status === 200 && response.data.message) {
          setError("");
          setSuccess(response.data.message);
          setFormData({
            name: "",
            phoneNumber: "",
            email: "",
            address: "",
            userName: "",
            password: "",
            description: "",
            type: "",
            status: true,
            pass_code: ""
          });
          imageRef.current.value = "";
          setImage("");
          setEnablePasscode()
        }
      } catch (error) {
        if (error.response && error.response.data.message) {
          setError(error.response.data.message);
          setSuccess("");
        } else {
          setError(error.message);
          setSuccess("");
        }
        console.log(error);
      }
    }
  };

  useEffect(() => {
    if (!localStorage.getItem("token")) {
      navigate("/auth");
    }
  }, [navigate]);

  useEffect(() => {
    setToken(localStorage.getItem("token"));
  }, [token]);




  useEffect(() => {
    if (token) {
      async function getData() {
        setIsLoading(true);
        try {
          const response = await axios.get(GetStaffTypeListURL, {
            headers: { authorization: `Bearer ${token}` },
          });

          if (response.status === 200 && response.data.staffRoles) {
            setStaffTypeOptions(response.data.staffRoles);
          }
          if (response.status === 200 && response.data.staffType) {
            setStaffType(response.data.staffType);
            setSelectedStaffType(response.data.staffType[0].staff_type)
          }
        } catch (error) {
          if (error.response && error.response.data.message) {
            addToast("error", error.response.data.message);
          } else {
            addToast("error", error.message);
          }
          console.log(error);
        }
        setIsLoading(false);
      }
      getData();
    }
  }, [token, addToast]);

  useEffect(() => {
    if (error || success) {
      window.scrollTo(0, 0);
    }
  }, [error, success]);

  const [permissions, setPermissions] = useState([]);

  // useEffect(() => {
  //   const groupedPermissions = StaffPermissions

  //   setPermissions(groupedPermissions);
  // }, [StaffPermissions]);


  const handleGroupToggle = (groupIndex) => {
    const updatedPermissions = permissions.map((group, idx) => {
      if (idx === groupIndex) {
        const isNowVisible = !group.visible;

        return {
          ...group,
          visible: isNowVisible,
          permissions: group.permissions.map((perm) => ({
            ...perm,
            permission: isNowVisible ? perm.permission : false, // uncheck if hiding
          })),
        };
      }
      return group;
    });

    setPermissions(updatedPermissions);
  };


  const handlePermissionChange = (id) => {
    const updatedPermissions = permissions.map((group) => ({
      ...group,
      permissions: group.permissions.map((perm) =>
        perm.id === id ? { ...perm, permission: !perm.permission } : perm
      ),
    }));
    setPermissions(updatedPermissions);
  };


  // useEffect(() => {

  //   console.log(permissions)
  // }, [permissions]);

  // const getFlattenedPermissionObject = () => {
  //   const result = {};
  //   console.log(permissions)

  //   permissions.forEach((group) => {
  //     // Determine group-level true/false
  //     const isGroupChecked = group.permissions.some((perm) => perm.permission === true);
  //     result[group.name] = isGroupChecked;

  //     // Add each permission in group
  //     group.permissions.forEach((perm) => {
  //       result[perm.name] = perm.permission;
  //     });
  //   });

  //   return result;
  // };

  const getFlattenedPermissionObject = () => {
    const result = {};

    permissions.forEach((group) => {
      // Use group.visible instead of checking permissions
      result[group.name] = group.visible;

      // Add each permission in group (if needed)
      group.permissions.forEach((perm) => {
        result[perm.name] = perm.permission;
      });
    });

    return result;
  };

  return (
    <>
      {token && (
        <>
          <div
            className={
              toggleSideBar
                ? "container-scroller sidebar-icon-only"
                : "container-scroller"
            }
          >
            <nav className="navbar default-layout col-lg-12 col-12 p-0 fixed-top d-flex align-items-top flex-row">

              <div className="text-center navbar-brand-wrapper d-flex align-items-center justify-content-start">
                <Link className="navbar-brand brand-logo-mini" to="/fooders_cp">
                  {/* <img src="images/mini-kr-logo.svg" alt="logo" />     */}
                </Link>
                <div className="me-1">
                  <button
                    className={
                      toggleSideBar
                        ? "navbar-toggler navbar-toggler align-self-center"
                        : "navbar-toggler navbar-toggler align-self-center text-white"
                    }
                    type="button"
                    onClick={handleToggleSidebar}
                  >
                    <span className="icon-menu"></span>
                  </button>
                </div>
                <div>
                  <Link to="/fooders_cp">
                    <span className="navbar-brand brand-logo">
                      <img src="images/vyfoo_logo.png" alt="logo" />
                    </span>
                  </Link>
                </div>
              </div>
              <NavBar handleToggle={handleToggleOffCanvas} toggleCanvas={toggleSideBar} />
            </nav>
            <div className="container-fluid page-body-wrapper px-0">
              <SideBar active="view_staff" toggleCanvas={toggleSideBar} />

              <div className="main-panel">
                <div className="content-wrapper">
                  <div className="row">
                    <div className="col-sm-12">
                      <h3 className="ukhd mb-3">Staff</h3>
                      <div className="row flex-grow">
                        <div className="col-12 grid-margin stretch-card">
                          <div className="card card-rounded">
                            <div className="card-body">
                              <div className="d-flex justify-content-between align-items-start mb-2">
                                <div className="vsalign">
                                  <h4 className="card-title card-title-dash">
                                    Add Staff
                                  </h4>
                                </div>
                                <div className="vsalign">
                                  <span
                                    className="btn btn-danger mb-0 me-0"
                                    onClick={handleBackClick}
                                  >
                                    <i className="menu-icon mdi mdi-arrow-left vsalign"></i>
                                    Go Back
                                  </span>
                                </div>
                              </div>
                              <form className="forms-sample">
                                {error && (
                                  <div className="d-flex justify-content-between align-items-start alert alert-danger">
                                    <div className="vsalign">{error}</div>
                                    <div className="vsalign">
                                      <span
                                        className=".h3 text-muted"
                                        style={{ cursor: "pointer" }}
                                        onClick={() => setError("")}
                                      >
                                        x
                                      </span>
                                    </div>
                                  </div>
                                )}
                                {success && (
                                  <div className="d-flex justify-content-between align-items-start alert alert-success">
                                    <div className="vsalign">{success}</div>
                                    <div className="vsalign">
                                      <span
                                        className=".h3 text-muted"
                                        style={{ cursor: "pointer" }}
                                        onClick={() => setSuccess("")}
                                      >
                                        x
                                      </span>
                                    </div>
                                  </div>
                                )}
                                <div className="row">
                                  <div className="col-12 col-md-6 col-lg-6">
                                    <div className="form-group">
                                      <label>
                                        Name
                                        <span className="text-danger">*</span>
                                      </label>
                                      <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter  Name"
                                        name="name"
                                        value={formData.name}
                                        onChange={handleInputChange}
                                      />
                                    </div>
                                  </div>

                                  <div className="col-12 col-md-6 col-lg-6">
                                    <div className="form-group">
                                      <label>
                                        Phone Number
                                        <span className="text-danger">*</span>
                                      </label>
                                      <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter Phone Number"
                                        maxLength={10}
                                        name="phoneNumber"
                                        value={formData.phoneNumber}
                                        onChange={handleInputChange}
                                      />
                                    </div>
                                  </div>

                                  <div className="col-12 col-md-6 col-lg-6">
                                    <div className="form-group">
                                      <label> Email </label>
                                      <input
                                        type="email"
                                        className="form-control"
                                        placeholder="Enter Email"
                                        name="email"
                                        value={formData.email}
                                        onChange={handleInputChange}
                                      />
                                    </div>
                                  </div>

                                  <div className="col-12 col-md-6 col-lg-6">
                                    <div className="form-group">
                                      <label> Address </label>
                                      <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter Address"
                                        name="address"
                                        value={formData.address}
                                        onChange={handleInputChange}
                                      />
                                    </div>
                                  </div>

                                  <div className="col-12 col-md-6 col-lg-6">
                                    <div className="form-group">
                                      <label>
                                        User Name
                                        <span className="text-danger">*</span>
                                      </label>
                                      <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter User Name"
                                        name="userName"
                                        value={formData.userName}
                                        onChange={handleInputChange}
                                      />
                                    </div>
                                  </div>

                                  <div className="col-12 col-md-6 col-lg-6">
                                    <div className="form-group">
                                      <label>
                                        Password
                                        <span className="text-danger">*</span>
                                      </label>
                                      <input
                                        type="password"
                                        className="form-control"
                                        placeholder="Enter  Password"
                                        name="password"
                                        value={formData.password}
                                        onChange={handleInputChange}
                                      />
                                    </div>
                                  </div>







                                  {/* <div className="col-12 col-md-6 col-lg-6">
                                    <div className="form-group">
                                      <label>
                                        Select Staff Type
                                        <span className="text-danger">*</span>
                                      </label>
                                      <select
                                        className="form-select"
                                        name="type"
                                        value={formData.type}
                                        onChange={handleInputChange}
                                      >
                                        <option value="">
                                          Select Staff Type
                                        </option>
                                        {staffTypeOptions.map((item) => (
                                          <option
                                            key={item.numeric}
                                            value={item.numeric}
                                          >
                                            {item.name}
                                          </option>
                                        ))}
                                      </select>
                                    </div>
                                  </div> */}



                                  <div className="col-12 col-md-6 col-lg-6">
                                    <div className="form-group">
                                      <label>Upload Image </label>
                                      <br />
                                      {formData.image && (
                                        <img
                                          src={formData.image}
                                          className="mb-2"
                                          alt="staff_image"
                                          style={{
                                            width: "120px",
                                            height: "auto",
                                          }}
                                        />
                                      )}

                                      <input
                                        className="form-control"
                                        type="file"
                                        accept=".jpeg, .jpg, .png"
                                        id="formFile"
                                        ref={imageRef}
                                        name="image"
                                        onChange={(e) =>
                                          setImage(e.target.files[0])
                                        }
                                      />
                                      <p className="text-danger">Recommended size: 200 × 200 px <br />
                                        Maximum size: 500 × 500 px (up to 1 MB)<br />
                                        Supported formats: JPG, JPEG, PNG</p>
                                    </div>
                                  </div>

                                  <div className="col-12 col-md-6 col-lg-6">
                                    <div className="form-group togglecss">
                                      <label>Status</label>
                                      <div className="button r" id="button-1">
                                        <input
                                          type="checkbox"
                                          className="checkbox"
                                          name="status"
                                          checked={formData.status}
                                          onChange={handleInputChange}
                                        />
                                        <div className="knobs"></div>
                                        <div className="layer"></div>
                                      </div>
                                    </div>
                                  </div>





                                  <div className="col-12 col-md-12 col-lg-12">
                                    <label>
                                      Select Staff Type
                                      <span className="text-danger">*</span>
                                    </label>

                                    <div >
                                      {staffType.map((item) => (
                                        <div
                                          className="form-check form-check-inline mx-2 my-2"
                                          key={item.staff_type}
                                        >
                                          <input
                                            className="form-check-input"
                                            type="radio"
                                            name="staff_type"
                                            value={item.staff_type}
                                            checked={selectedStaffType === item.staff_type}
                                            onChange={(e) => {
                                              setSelectedStaffType(e.target.value);
                                              setFormData({
                                                ...formData,
                                                type: ""
                                              });
                                              setEnablePasscode(0)
                                            }}

                                          />
                                          <label className="form-check-label">
                                            {item.staff_type}
                                          </label>
                                        </div>
                                      ))}
                                    </div>
                                    <div className="form-group">

                                      {staffTypeOptions.map((item) => (
                                        <>
                                          {item.staff_type === selectedStaffType ?


                                            <div
                                              style={{ minHeight: "110px" }}
                                              key={item.type}
                                              onClick={() => { handleInputStafe(item.id); setPermissions(item.permission); setEnablePasscode(item.enable_passcode) }}
                                              className={
                                                item.id === formData.type ? "stafe-selectd-card p-3 mb-3 position-relative" : "stafe-card p-3 mb-3 position-relative"
                                              }
                                            >

                                              {/* Copy Icon - Top Right */}

                                              {/* {item.visit_link ?


                                                <span

                                                  className="copy-icon"
                                                  onClick={(e) => {
                                                    e.stopPropagation();           // card click prevent
                                                    navigator.clipboard.writeText(item.visit_link);

                                                    addToast("success", "Link copy!");
                                                  }}
                                                  style={{
                                                    position: "absolute",
                                                    top: "8px",
                                                    right: "8px",
                                                    cursor: "pointer",
                                                    fontSize: "16px"
                                                  }}
                                                >
                                                  <i

                                                    data-tooltip-content={`Click to copy the ${item.name} panel link`}
                                                    data-tooltip-place="top"
                                                    className="mdi mdi-content-copy"></i>
                                                </span>

                                                : <></>} */}

                                              <div className="card-header p-2 mb-1">
                                                <h6 className="m-0 d-flex align-items-center">
                                                  {item.name}&nbsp;
                                                </h6>
                                              </div>

                                              <p style={{ fontSize: "10px" }} className="m-0 mt-2">
                                                {item.permission_name}
                                              </p>
                                              <Link
                                                style={{ fontSize: "12px", color: "blue" }}
                                                target="_blank"
                                                to={item.visit_link}
                                                className="m-0 mt-1"
                                                onClick={(e) => {
                                                  e.stopPropagation();
                                                }}
                                              >
                                                {item.visit_link}
                                              </Link>

                                            </div>

                                            : <></>}


                                        </>

                                      ))}

                                    </div>


                                  </div>


                                  {enablePasscode ?
                                    <div className="col-12 col-md-6 col-lg-6">
                                      <div className="form-group">
                                        <label>
                                          Pass code
                                          <span className="text-danger">*</span>
                                        </label>
                                        <input
                                          type="text"
                                          className="form-control"
                                          placeholder="Enter Pass code"
                                          name="pass_code"
                                          value={formData.pass_code}
                                          onChange={(e) => {
                                            const value = e.target.value.replace(/\D/g, ""); // Remove non-digits
                                            handleInputChange({ target: { name: "pass_code", value } });
                                          }}
                                        />
                                      </div>
                                    </div>
                                    : <></>}










                                </div>

                                {formData.type !== "" && permissions.length > 0 ? <>

                                  <div className="col-12 col-md-6 col-lg-6 mt-3">
                                    <label>Permissions</label>
                                    <div className="form-group">
                                      {permissions.map((group, idx) => (
                                        <div key={idx} className="mb-3 border p-2 rounded bg-light">
                                          {/* Group checkbox */}
                                          <div className="form-check mb-2">
                                            <input
                                              className="form-check-input"
                                              type="checkbox"
                                              id={`group-${idx}`}
                                              checked={group.visible}
                                              onChange={() => handleGroupToggle(idx)}
                                            />
                                            <label className="form-check-label fw-bold" htmlFor={`group-${idx}`}>
                                              {group.title}
                                            </label>
                                          </div>

                                          {/* Child permissions - only show when group.visible is true */}
                                          {group.visible &&
                                            group.permissions.map((permission) => (
                                              <div className="form-check ms-3" key={permission.id}>
                                                <input
                                                  className="form-check-input"
                                                  type="checkbox"
                                                  id={`perm-${permission.id}`}
                                                  checked={permission.permission}
                                                  onChange={() => handlePermissionChange(permission.id)}
                                                />
                                                <label
                                                  className="form-check-label"
                                                  htmlFor={`perm-${permission.id}`}
                                                >
                                                  {permission.label}
                                                </label>
                                              </div>
                                            ))}
                                        </div>
                                      ))}
                                    </div>

                                  </div>


                                </> : <></>}





                                <div className="form-group">
                                  <label>Description</label>
                                  <textarea
                                    className="form-control"
                                    placeholder="Enter Description"
                                    name="description"
                                    value={formData.description}
                                    onChange={handleInputChange}
                                  ></textarea>
                                </div>

                                <button
                                  type="submit"
                                  className="btn btn-primary me-2"
                                  onClick={handleAddStaff}
                                >
                                  Submit
                                </button>
                                <button
                                  className="btn btn btn-secondary"
                                  onClick={handleBackClick}
                                >
                                  Cancel
                                </button>
                              </form>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <LoadingModal isLoading={isLoading} />
          <Tooltip anchorSelect=".mdi" />

          <Notification />
        </>
      )}
    </>
  );
};

export default AddStaff;
